import React, { useContext, useEffect, useState } from "react";
import { API, Storage, graphqlOperation } from "aws-amplify";
import Edit from "../../assets/hugeicons_mail-edit-01.svg"; // Import the SVG image
import Send from "../../assets/iconoir_send.svg"; // Import the SVG image
import close from "../../assets/carbon_close-outline.svg"; // Import the SVG image
import { SpotContext } from "../../context/SpotContext";
import { createSpotCandidateStatus, updateSpotCandidateStatus, updateSpotJD, updateSpotResume } from "../../graphql/mutations";

import {sendEmailAPIforCompany} from "../Utils/SendmailForCompany";
import { getSpotCandidateStatus, listSpotCandidateStatuses } from "../../graphql/queries";

function SpotPlusSendMailPopupinSpotGPT({ onClose, onTargetActive }) {

  const [companyProfile, setCompanyProfile] = useState(null);

  // target candidate code start

  const [mailsendCandidates, setMailsendCandidates] = useState([]);

  // target candidate code end

  // Store code start

  const {
    gptActivatedFor,
    selectedcandidates_referring_to,

  } = useContext(SpotContext);

  // Store code end

  console.log("kkkkkkkkkkkkkkkk",gptActivatedFor)
  console.log("llllllllllllllll",selectedcandidates_referring_to)

  useEffect(() => {

    const storedProfile = localStorage.getItem('CompanyProfile');


    if (storedProfile) {
      try {
        // Parse the JSON string into an object
        const profileObject = JSON.parse(storedProfile);
        setCompanyProfile(profileObject);
      } catch (error) {
        // console.error('Error parsing CompanyProfile from localStorage:', error);
      }
    }

    // text formated intial phase code start

    const htmlContent = `
    <html>
      <body>
        ${content
        .split("\n")
        .map((line) => {
          if (line.trim() === "") return ""; // Skip empty lines
          if (line.startsWith("-")) return `<li>${line.substring(1).trim()}</li>`; // Bullet points
          return `<p>${line.trim()}</p>`; // Wrap other lines in <p>
        })
        .join("\n")}
      </body>
    </html>
    `;

    setFormattedHTMLContent(htmlContent.trim());

    // test formated intial phase code end

  }, [])

  const [isEditable, setIsEditable] = useState(false);
  // Define your email template with placeholders

  const emailTemplate = `Subject: Congratulations! You’ve Been Shortlisted for the [Position Name]

Dear [Candidate's Name],

I hope this email finds you well.

We are pleased to inform you that you have been shortlisted for the next stage of the interview process for the [Position Name] role at [Company Name].

After reviewing your application and qualifications, we believe that your skills and experiences align well with what we are looking for in this role.

Interview Details:

Date: January 10, 2025
Interview Type: Virtual
Location/Platform: Zoom link: https://zoom.us/j/123456789
The interview will primarily focus on your knowledge and expertise in artificial intelligence, as well as how your experiences can contribute to TechCorp. It will also provide an opportunity for you to share your thoughts on how AI can shape the future at TechCorp.

Please confirm your availability for the interview by replying to this email at your earliest convenience.

Should you have any questions or need any additional information prior to the interview, feel free to reach out to us.

We are excited to learn more about you and discuss how you can be a great addition to our team.

Best regards,

[Your Name]
`;


  // Set the email template as the initial content
  const [content, setContent] = useState(emailTemplate);

  const handleEditClick = () => {
    setIsEditable(true);
  };


  const [formattedHTMLContent, setFormattedHTMLContent] = useState(content);

  const handleSaveClick = () => {
    setIsEditable(false);
    // When saving, convert plain text into HTML format
    // const htmlContent = convertToHTML(content);
    // setContent(htmlContent);


    const htmlContent = `
<html>
  <body>
    ${content
        .split("\n")
        .map((line) => {
          if (line.trim() === "") return ""; // Skip empty lines
          if (line.startsWith("-")) return `<li>${line.substring(1).trim()}</li>`; // Bullet points
          return `<p>${line.trim()}</p>`; // Wrap other lines in <p>
        })
        .join("\n")}
  </body>
</html>
    `;

    setFormattedHTMLContent(htmlContent.trim());

  };


  const [candidates, setCandidates] = useState(selectedcandidates_referring_to)

  // Mock API function to send emails
  const sendEmailAPI = async (candidate, subject, body) => {

    // const res = await sendEmailAPIforCompany(candidate.email,subject,body,spotprocessSelectedJD.companyEmail);

    // console.log("res", res);

    // const isEmailSent = res.message === "Email sent successfully"; // This will return a boolean (true/false)

   const candidateEmail =  candidate.email
   const spotJdID = gptActivatedFor.id

   const handleCandidateStatus = async (spotJdID, candidateEmail, gptActivatedFor) => {
    try {
      let candidateStatusList = [];
      let currentNextToken = null;
  
      // Step 1: Fetch existing status using filters
      do {
        const { data } = await API.graphql(
          graphqlOperation(listSpotCandidateStatuses, {
            filter: {
              spotJdID: { eq: spotJdID }, 
              candidateEmail: { eq: candidateEmail }, 
            },
            nextToken: currentNextToken,
          })
        );
  
        const candidateData = data?.listSpotCandidateStatuses || {};
        const items = candidateData.items || [];
  
        candidateStatusList = [...candidateStatusList, ...items];
  
        currentNextToken = candidateData.nextToken;
      } while (currentNextToken);
  
      console.log("Fetched Candidate Status:", candidateStatusList);
  
      // Step 2: If candidate status exists → UPDATE
      if (candidateStatusList.length > 0) {
        const existingCandidate = candidateStatusList[0]; // Take the first matching record
  
        const updateInput = {
          id: existingCandidate.id, // Required for update
          spotJdID: existingCandidate.spotJdID,
          candidateEmail: existingCandidate.candidateEmail,
          roundStatus: "secondRound",
          isEmailsend: true,
          candidateFrom: existingCandidate.candidateFrom, // Retain existing data
          selectionFlag: existingCandidate.selectionFlag, // Retain existing data
          // updatedAt: new Date().toISOString(),
        };
  
        const updateResponse = await API.graphql(
          graphqlOperation(updateSpotCandidateStatus, { input: updateInput })
        );
  
        console.log("✅ Candidate Status Updated:", updateResponse.data.updateSpotCandidateStatus);
      } 
      // Step 3: If no record found → CREATE a new one
      else {
        const createInput = {
          companyEmail: gptActivatedFor.companyEmail,
          spotResumeID: gptActivatedFor.spotResumeID,
          spotJdID: gptActivatedFor.id,
          candidateEmail: candidateEmail,
          roundStatus: "secondround",
          isEmailsend: true,
          candidateFrom: "Resume",
          selectionFlag: "",
          // createdAt: new Date().toISOString(),
        };
  
        const createResponse = await API.graphql(
          graphqlOperation(createSpotCandidateStatus, { input: createInput })
        );
  
        console.log("✅ New Candidate Status Created:", createResponse.data.createSpotCandidateStatus);
      }
    } catch (error) {
      console.error("❌ Error handling candidate status:", error);
    }
  };
  
  // 🔥 Example Usage:
  handleCandidateStatus(gptActivatedFor.id, candidate.email, gptActivatedFor);

    // const clearData = () => {


    // }

    // clearData()

  };

  const handleSendMailClick = async () => {

    if (
      !gptActivatedFor || typeof gptActivatedFor !== 'object' ||
      !selectedcandidates_referring_to || !Array.isArray(selectedcandidates_referring_to) || selectedcandidates_referring_to.length === 0 
    ) {
      alert("Please Select the Candidates first before proceeding with sending emails."); // Alert the user
      return; // Exit the function
    }


    const subject = `Congratulations! You’ve Been Shortlisted for the ${gptActivatedFor.jdName}`;

    for (const candidate of candidates) {
      const personalizedContent = formattedHTMLContent
        .replace(/\[Candidate's Name\]/g, candidate.name)
        .replace(/\[Position Name\]/g, gptActivatedFor.jdName) // Ensure this is being replaced
        .replace(/\[Company Name\]/g, companyProfile.companyName)
        .replace(/\[Insert Date\]/g, "January 10, 2025")
        .replace(/\[Virtual\/In-person\]/g, "Virtual")
        .replace(/\[Your Name\]/g, companyProfile.companyName)
        .replace(
          /\[Insert Platform Link or Physical Address\]/g,
          "Zoom link: https://zoom.us/j/123456789"
        );

      console.log("uuuuuuuuuuuuu", personalizedContent);


      await sendEmailAPI(candidate, subject, personalizedContent);
    }

    alert("Emails have been sent successfully!");
    // onClose();
  };



  //  sending Email code end


  return (
    <div style={styles.container}>
      <div style={styles.canvas}>
        <button onClick={onClose} >
          <img src={close} />
        </button>
        <div style={styles.editButtoncontainer}>
          <img onClick={handleEditClick} src={Edit} />

          <img onClick={handleSendMailClick} src={Send} />
        </div>
        <textarea
          style={{ ...styles.textarea, display: isEditable ? "block" : "none" }}
          value={content}
          onChange={(e) => setContent(e.target.value)}
          readOnly={!isEditable}
        />

        {/* <p
          style={{
            // ...styles.textContent,
            ...styles.textarea,
            display: !isEditable ? "block" : "none",
          }}
        >
           {content} 
        </p> */}

        <p
          style={{
            ...styles.textarea,
            display: !isEditable ? "block" : "none",
          }}
          dangerouslySetInnerHTML={{
            // __html: content, // Render content as text
            __html: formattedHTMLContent, // Render content as text
          }}
        />

        <div style={styles.actionButtonContainer}>
          {/* Always show the Send Mail button */}
          {!isEditable && (
            <button style={styles.actionButton}
              //  onClick={handleSendMailClick}
              onClick={handleSendMailClick}
            >
              Send Mail
            </button>
          )}

          {isEditable && (
            <button style={styles.actionButton} onClick={handleSaveClick}>
              Save
            </button>
          )}
        </div>
      </div>
    </div>
  );
}

const styles = {
  container: {
    display: "flex",
    flexDirection: "column",
    alignItems: "center",
    // justifyContent: "center",
    // height: "100vh",
    height: "54vh",
    padding: "20px",
    fontFamily: "Arial, sans-serif",
    zIndex: "12",
    width: "100%",
  },
  canvas: {
    position: "relative",
    width: "80%",
    // maxWidth: "600px",
    // minHeight: "70vh",
    height: "70vh",
    padding: "20px",
    border: "1px solid #ccc",
    borderRadius: "8px",
    boxShadow: "0 4px 8px rgba(0, 0, 0, 0.2)",
    background: "#ddc8ff",
    display: "grid",
    // marginTop: "8rem",
    overflowY: "scroll"
  },
  textarea: {
    width: "100%",
    minHeight: "100vh",
    fontSize: "16px",
    lineHeight: "1.5",
    padding: "10px",
    border: "none",
    outline: "none",
    resize: "none",
    fontFamily: "inherit",
    color: "#000",
    borderRadius: "8px",
  },
  textContent: {
    width: "100%",
    minHeight: "40vh",
    fontSize: "16px",
    lineHeight: "1.5",
    color: "#333",
    padding: "3% 1%",
  },
  editButton: {
    position: "absolute",
    top: "10px",
    right: "10px",
    background: "transparent",
    border: "none",
    fontSize: "18px",
    cursor: "pointer",
  },
  actionButton: {
    // position: "absolute",
    bottom: "10px",
    left: "10px",
    padding: "8px 16px",
    fontSize: "14px",
    color: "#fff",
    background:
      "linear-gradient(180deg, rgb(102, 126, 234) 0%, rgb(136, 89, 184) 100%)",
    border: "none",
    borderRadius: "4px",
    cursor: "pointer",
    display: "grid",
  },
  editButtoncontainer: {
    display: "flex",
    border: "1px solid #243642",
    background: "#ffffffad",
    width: "fit-content",
    height: "38px",
    padding: "4px 8px",
    gap: "16px",
    borderRadius: "4px",
    justifySelf: "end",
  },
  actionButtonContainer: {
    display: "flex",
    alignItems: "end",
    justifyContent: "end",
  },
};
export default SpotPlusSendMailPopupinSpotGPT;
